
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bZz8I", function(module, exports) {
/* SuperAdminEntryPoint.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $cs1vW = parcelRequire("cs1vW");


var $T1bCI = parcelRequire("T1bCI");


var $1DWH0 = parcelRequire("1DWH0");


var $4KS7f = parcelRequire("4KS7f");


var $30qWc = parcelRequire("30qWc");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $8lYIw = parcelRequire("8lYIw");


var $6jrkJ = parcelRequire("6jrkJ");


var $gqqjz = parcelRequire("gqqjz");


var $f7tt0 = parcelRequire("f7tt0");


var $aivVq = parcelRequire("aivVq");

/**
 * @generated SignedSource<<1885c7e4569330c8d6b7c91db67cf5da>>
 * @relayHash b291183164e54b61ac41c7ac3a91ac01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0f7a323c6163ddb2c5139bf05639e0215bef2eaec201056a60dd9d2dbcdb646d
const $dcd708e6fe6bc342$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphQLConfluenceUserRoles",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isSuperAdmin"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EnableSuperAdminMutation",
            "selections": [
                {
                    "concreteType": "SuperAdminPayload",
                    "kind": "LinkedField",
                    "name": "enableSuperAdmin",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EnableSuperAdminMutation",
            "selections": [
                {
                    "concreteType": "SuperAdminPayload",
                    "kind": "LinkedField",
                    "name": "enableSuperAdmin",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v0 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b291183164e54b61ac41c7ac3a91ac01",
            "id": "0f7a323c6163ddb2c5139bf05639e0215bef2eaec201056a60dd9d2dbcdb646d",
            "metadata": {},
            "name": "EnableSuperAdminMutation",
            "operationKind": "mutation",
            "text": "mutation EnableSuperAdminMutation{enableSuperAdmin{user{id,confluence{roles{isSuperAdmin}}},id}}"
        }
    };
}();
$dcd708e6fe6bc342$var$node.hash = "4e0079a7f1ee60e3ad64031d0daad593";
var $dcd708e6fe6bc342$export$2e2bcd8739ae039 = $dcd708e6fe6bc342$var$node;


const $78e58a56025e869a$export$e35a7dfdbcd24208 = (0, $dcd708e6fe6bc342$export$2e2bcd8739ae039);



var $5sbfe = parcelRequire("5sbfe");

function $8bb0a631ae3d7aa4$var$_defineProperty(e, r, t) {
    return (r = $8bb0a631ae3d7aa4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8bb0a631ae3d7aa4$var$_toPropertyKey(t) {
    var i = $8bb0a631ae3d7aa4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8bb0a631ae3d7aa4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $8bb0a631ae3d7aa4$export$85edf49b92ebf29f = '1ePHWZLYCbUCb5HG1OqZf2';
const $8bb0a631ae3d7aa4$var$i18n = (0, $h82at.defineMessages)({
    enableSuperAdminErrorTitle: {
        id: "super-admin.enable.super.admin.error.title",
        defaultMessage: "Something went wrong"
    },
    enableSuperAdminErrorDescription: {
        id: "super-admin.enable.super.admin.error.description",
        defaultMessage: "Please refresh and try again."
    }
});
const $8bb0a631ae3d7aa4$export$25353f2d9483d9dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $8bb0a631ae3d7aa4$export$1ff3c3f08ae963c0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8h8dc _1bsb1ylp _y3gn1h6o",
            __cmplp.className
        ])
    });
});
class $8bb0a631ae3d7aa4$export$d4f181b6ed7619aa extends (0, $42omo.Component) {
    constructor(...args){
        super(...args);
        /**
     * Executed after the mutation is complete.
     * It is used to set the Super Admin claim, and refresh the page to update elevated restrictions.
     * @param {object} flags
     * @param {object} session
     * @return {function}
     */ $8bb0a631ae3d7aa4$var$_defineProperty(this, "handleMutationComplete", (flags)=>(result)=>{
                const superAdminSuccessfullyEnabled = result?.enableSuperAdmin?.user?.confluence?.roles?.isSuperAdmin;
                if (superAdminSuccessfullyEnabled) {
                    (0, $6jrkJ.setSuperAdminClaim)();
                    (0, $5sbfe.refreshAKTimeout)();
                    this.props.createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'superAdminEntryPoint',
                            action: 'started',
                            actionSubject: 'adminKeySession'
                        }
                    }).fire();
                    const reloadCallback = ()=>window.location.reload(); // refresh the page on both resolve and reject of the promise as error handling is tricky here.
                    // Considered the options:
                    // 1. Showing a flag with error message and reloading
                    //   - Flags don't seem preserve after reload
                    // 2. Showing a flag with error message and not reloading
                    //   - AK session is already acquired so its not a great user experience if we don't reflect it in the UI.
                    //     And currently refreshing the page is the way for Admin key banner to show up.
                    this.storeConfirmedPage();
                    reloadCallback();
                } else this.handleMutationError(flags)();
            });
        /**
     * Error handling mechanism for network or server errors.
     * @param {object} flags
     * @return {function}
     */ $8bb0a631ae3d7aa4$var$_defineProperty(this, "handleMutationError", (flags)=>()=>{
                const { intl: intl, createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'superAdminEntryPoint',
                        action: 'failed',
                        actionSubject: 'startAdminKeySession'
                    }
                }).fire();
                flags.showErrorFlag({
                    title: intl.formatMessage($8bb0a631ae3d7aa4$var$i18n.enableSuperAdminErrorTitle),
                    description: intl.formatMessage($8bb0a631ae3d7aa4$var$i18n.enableSuperAdminErrorDescription)
                });
            });
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "learnMoreClicked", ()=>{
            this.props.createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'adminKeyLearnMore',
                    source: 'superAdminEntryPoint'
                }
            }).fire();
            /**
       * Since EP is used for feature-based proactive billing experiment, generic events like link clicked
       * cannot be used. Since in EP only action & actionSubject  can be used.
       */ this.props.createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'adminKeyLearnMoreLink',
                    source: 'superAdminEntryPoint'
                }
            }).fire();
        });
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "viewNowClicked", (enableSuperAdmin)=>{
            this.props.createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'adminKeyViewNow',
                    source: 'superAdminEntryPoint'
                }
            }).fire();
            enableSuperAdmin();
        });
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "storeConfirmedPage", ()=>{
            const { contentId: contentId } = this.props;
            if (contentId) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED, contentId);
        });
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "fireAnalyticsEvent", (articleId)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'helpLink',
                    source: 'superAdminEntryPoint',
                    attributes: {
                        targetArticleId: articleId,
                        isSPA: true
                    }
                }
            }).fire();
        });
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "renderActions", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $78e58a56025e869a$export$e35a7dfdbcd24208),
                    onError: this.handleMutationComplete(flags),
                    onCompleted: this.handleMutationComplete(flags)
                }, (enableSuperAdmin)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bb0a631ae3d7aa4$export$25353f2d9483d9dd, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                        appearance: "primary",
                        onClick: ()=>this.viewNowClicked(enableSuperAdmin)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        id: "super-admin.start.session",
                        defaultMessage: "View now"
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bb0a631ae3d7aa4$export$1ff3c3f08ae963c0, null, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
                        articleId: $8bb0a631ae3d7aa4$export$85edf49b92ebf29f,
                        articleTopic: "super-admin-entry-point",
                        onClick: ()=>this.fireAnalyticsEvent($8bb0a631ae3d7aa4$export$85edf49b92ebf29f)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        id: "super-admin.learn.more",
                        defaultMessage: "Learn more"
                    }))))));
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "renderTitle", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "super-admin.entry.point.title",
                defaultMessage: "View now with admin key",
                "data-test-id": "super-admin-entry-point-title"
            }));
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "renderMessage", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "super-admin.entry.point.message",
                defaultMessage: "As a {canBeSuperAdmin} with Premium, you can use your admin key to view restricted content. We\u2019ll log any restricted content you view and notify the owners.",
                tagName: "p",
                values: {
                    canBeSuperAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
                        target: "_blank",
                        to: "/admin/users?role=site%2Fadmin"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        id: "super-admin.entry.point.message.can-be-super-admin",
                        defaultMessage: "site admin"
                    }))
                },
                "data-test-id": "super-admin-entry-point-message"
            }));
        $8bb0a631ae3d7aa4$var$_defineProperty(this, "render", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aivVq.AdminKeyMessageCard), {
                title: this.renderTitle(),
                message: this.renderMessage(),
                actions: this.renderActions(),
                eventName: "superAdminEntryPoint",
                type: this.props.type
            }));
    }
}
$8bb0a631ae3d7aa4$var$_defineProperty($8bb0a631ae3d7aa4$export$d4f181b6ed7619aa, "propTypes", {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'page',
        'space'
    ])
});
const $8bb0a631ae3d7aa4$export$f265d8a86f21f5a8 = (0, $1DWH0.default)()((0, $cs1vW.default)($8bb0a631ae3d7aa4$export$d4f181b6ed7619aa));
module.exports["LEARN_MORE_ARTICLE_ID"] = $8bb0a631ae3d7aa4$export$85edf49b92ebf29f;
module.exports["EntryPointActions"] = $8bb0a631ae3d7aa4$export$25353f2d9483d9dd;
module.exports["Separator"] = $8bb0a631ae3d7aa4$export$1ff3c3f08ae963c0;
module.exports["SuperAdminEntryPointComponent"] = $8bb0a631ae3d7aa4$export$d4f181b6ed7619aa;
module.exports["SuperAdminEntryPoint"] = $8bb0a631ae3d7aa4$export$f265d8a86f21f5a8;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("gYAjp"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("gYAjp", function(module, exports) {

let $c5be6abedcfce6ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5be6abedcfce6ba$var$load("6jGZ7"),
    $c5be6abedcfce6ba$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("aivVq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bhvFb = parcelRequire("bhvFb");


var $ctFLz = parcelRequire("ctFLz");

function $b4b18a5e12cbffbd$export$9b26f9bfbf657163(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { eventName: eventName, type: entryType } = props;
    (0, $42omo.useEffect)(()=>{
        // Fire analytics events only on the first time through
        if (createAnalyticsEvent) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: eventName,
                    action: 'viewed',
                    actionSubject: 'page',
                    actionSubjectId: eventName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: eventName,
                    attributes: {
                        entryType: entryType
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        eventName,
        entryType
    ]);
    const children = props['children'];
    const title = props['title'];
    const message = props['message'];
    const actions = props['actions'];
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        edition: (0, $ctFLz.ConfluenceEdition).PREMIUM,
        title: title,
        body: message,
        actions: actions
    });
}
module.exports["AdminKeyMessageCard"] = $b4b18a5e12cbffbd$export$9b26f9bfbf657163;

});

parcelRegister("ctFLz", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $250958848566956b$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["ConfluenceEdition"] = $250958848566956b$export$68577d543b14ae02;

});

parcelRegister("5sbfe", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $49629be71748f24e$var$logger = (0, $7W8i8.getLogger)('super-admin');
const $49629be71748f24e$export$a82b13920b2b393e = 10;
const $49629be71748f24e$export$f22454c74490db38 = 9;
const $49629be71748f24e$export$76d42d0ca67aebc = ($49629be71748f24e$export$a82b13920b2b393e - $49629be71748f24e$export$f22454c74490db38) * 60;
const $49629be71748f24e$export$f5b15d2658109778 = (time)=>Math.round((time - new Date().getTime()) / 1000);
const $49629be71748f24e$var$minutesToSeconds = (a)=>a * 60;
const $49629be71748f24e$export$508c4d06694f70cc = (date, minutes)=>$49629be71748f24e$export$fb4fed02def5f8e8(date, $49629be71748f24e$var$minutesToSeconds(minutes));
const $49629be71748f24e$export$3436fa457897ab63 = (date, minutes)=>$49629be71748f24e$export$fb4fed02def5f8e8(date, -$49629be71748f24e$var$minutesToSeconds(minutes));
const $49629be71748f24e$export$fb4fed02def5f8e8 = (date, seconds)=>new Date(date.getTime() + seconds * 1000);
const $49629be71748f24e$export$1ba688ed7c9193c6 = (timeout)=>({ beforeNotify: beforeNotify, afterNotify: afterNotify, afterExpiry: afterExpiry, noTimeout: noTimeout })=>{
        if (timeout) {
            const secondsRemainingForTimeout = $49629be71748f24e$export$f5b15d2658109778(timeout);
            const isTimeoutInFuture = secondsRemainingForTimeout > 0;
            const isTimeAfterNotify = secondsRemainingForTimeout <= $49629be71748f24e$export$76d42d0ca67aebc;
            if (isTimeoutInFuture) return isTimeAfterNotify ? afterNotify(timeout) : beforeNotify(timeout);
            else return afterExpiry(timeout);
        } else return noTimeout();
    };
const $49629be71748f24e$export$bffbcdd795a214e1 = ()=>{
    // The timeout value is read as a string from getItem() - or null if not found
    const timeout = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT);
    return timeout ? parseInt(timeout) : 0;
};
const $49629be71748f24e$export$b3e906649e13c955 = (time)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT, time.toString());
    } catch (_) {
        $49629be71748f24e$var$logger.error`Unable to set local storage. key = "${(0, $1UApO.keys).SUPER_ADMIN_TIMEOUT}", value = "${time}"`;
    }
};
const $49629be71748f24e$export$b767ec357fe1b622 = ()=>{
    (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT);
};
const $49629be71748f24e$export$c0d7e69a60d776a2 = ()=>{
    $49629be71748f24e$export$b3e906649e13c955($49629be71748f24e$export$508c4d06694f70cc(new Date(), $49629be71748f24e$export$a82b13920b2b393e).getTime());
};
module.exports["getSecondsBetweenNowAndTime"] = $49629be71748f24e$export$f5b15d2658109778;
module.exports["addSecondsToDate"] = $49629be71748f24e$export$fb4fed02def5f8e8;
module.exports["foldTimeout"] = $49629be71748f24e$export$1ba688ed7c9193c6;
module.exports["getAKTimeout"] = $49629be71748f24e$export$bffbcdd795a214e1;
module.exports["removeAKTimeout"] = $49629be71748f24e$export$b767ec357fe1b622;
module.exports["refreshAKTimeout"] = $49629be71748f24e$export$c0d7e69a60d776a2;

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});


//# sourceMappingURL=SuperAdminEntryPoint.7d098154.js.map
